import { CartAddEvent } from '@theme/events';
import { whenCartBatchIdle } from '@theme/cart-batch';
import { findBuyboxForm } from '@theme/hds-buybox-quantity';

/**
 * Offerteknop (HDS Sales-app) samen met «Maak je vloer compleet».
 *
 * De app zet alleen het hoofdproduct in de mand en gaat dan naar de offertepagina; de keuzes in de
 * samensteller kent hij niet. Is er in de samensteller iets gekozen, dan neemt dit script de klik
 * over: hetzelfde als «In winkelwagen» (vloer + alle onderdelen en diensten in één ronde, cart-batch.js),
 * daarna naar de offertepagina. Niets gekozen: de app doet het zoals altijd.
 */

const BUTTON = '#offerte-button';
const DEADLINE_MS = 15000;

/** Iets gekozen in de samensteller: een kiezer met een keuze of een aangevinkt toebehoren. */
function hasChoices() {
  if (!document.querySelector('floor-complete')) return false;
  return Boolean(document.querySelector('[data-fc-slot] [data-bbv-extra], [data-fc-slot] > [data-bbv-extra], variant-additional-products [data-vap-check]:checked'));
}

/** Wacht op het toevoegen van de vloer zelf (product-form.js stuurt een CartAddEvent). */
function floorAdded() {
  return new Promise((resolve, reject) => {
    const timer = setTimeout(() => reject(new Error('timeout')), DEADLINE_MS);
    /** @param {Event} event */
    const onAdd = (event) => {
      if (!(event instanceof CartAddEvent)) return;
      const detail = /** @type {any} */ (event).detail ?? {};
      const data = detail.data ?? {};
      if (data.source !== 'product-form-component') return;
      document.removeEventListener(CartAddEvent.eventName, onAdd);
      clearTimeout(timer);
      if (data.didError) reject(new Error('add_failed'));
      else resolve(detail);
    };
    document.addEventListener(CartAddEvent.eventName, onAdd);
  });
}

/** @param {MouseEvent} event */
async function onClick(event) {
  const button = event.target instanceof Element ? event.target.closest(BUTTON) : null;
  if (!(button instanceof HTMLButtonElement) || !hasChoices()) return;
  const form = findBuyboxForm(document.querySelector('floor-complete') ?? document.body);
  const add = form?.querySelector('button[name="add"], button[type="submit"]');
  if (!(add instanceof HTMLButtonElement)) return;

  // Vanaf hier doen wij het, niet de app.
  event.preventDefault();
  event.stopImmediatePropagation();
  if (button.classList.contains('offerte-button--loading')) return;

  const root = document.getElementById('pdp-quote-button-root');
  const redirect = root?.dataset.redirectPath || '/pages/offerte-aanvragen';
  // De winkelmand-lade niet openen: we gaan zo naar de offertepagina (zoals de app zelf ook doet).
  const drawer = document.querySelector('cart-drawer-component[auto-open]');
  drawer?.removeAttribute('auto-open');
  button.disabled = true;
  button.setAttribute('aria-busy', 'true');
  button.classList.add('offerte-button--loading');

  try {
    const added = floorAdded();
    // Zoals «In winkelwagen»: de kiezers leggen hun aantallen vast en liften mee (cart-batch.js).
    add.click();
    const detail = await added;
    await whenCartBatchIdle();
    window.dataLayer?.push({
      event: 'quote_pdp_add_success',
      productId: root?.dataset.productId,
      variantId: detail.sourceId,
      source: 'samensteller',
    });
    window.location.assign(redirect);
  } catch (error) {
    console.error('Offerte met samensteller mislukt:', error);
    drawer?.setAttribute('auto-open', '');
    button.disabled = false;
    button.removeAttribute('aria-busy');
    button.classList.remove('offerte-button--loading');
  }
}

if (!document.__hdsFloorQuote) {
  document.__hdsFloorQuote = true;
  // Capture: vóór de klikafhandeling van de app.
  document.addEventListener('click', onClick, true);
}
